module.exports = ""


//////////////////
// WEBPACK FOOTER
// /home/node/src/app/auth/logout/logout.component.html
// module id = ../../../../../src/app/auth/logout/logout.component.html
// module chunks = main